<template>
  <gs-named-modal class="gs-refresh-controls gs-aff-modal" name="edit-custom-landing-page-url" :title="$t('frontend_groovesell_edit_custom_landing_page_url')" width="600px" max-width="600px" >
    <form id="edit-custom-landing-page-url-form" class="gs-aff-form" @submit.prevent="editCustomLandingPage()">
      <p>Update the name and destination URL for your custom landing page.</p>
      <label>{{ $t('frontend_bonuses_name') }}
        <text-input v-model="localmodel.name" :validator="validator.model.name" :attribute="$t('frontend_name')" :placeholder="$t('frontend_name')" />
      </label>
      <label>{{ $t('frontend_bouses_link') }}
        <text-input v-model="localmodel.link" :validator="validator.model.link" attribute="Link" placeholder="https://" />
      </label>
    </form>
    <div slot="footer" class="gs-aff-footer">
      <gs-button variant="outline" @click="$root.$emit('modal-close', 'edit-custom-landing-page-url')">{{ $t('frontend_cancel') }}</gs-button>
      <gs-button variant="primary" type="submit" form="edit-custom-landing-page-url-form">{{ $t('frontend_update') }}</gs-button>
    </div>
  </gs-named-modal>
</template>
<script>
import "../../affiliate-workspace.css";
export default {
    props: {
        model: {
            required: true
        },
        validator: {
            required: true
        },
        editCustomLandingPage: {
            required: true,
            type: Function
        }
    },
    data() {
        return {
            localmodel: this.model
        }
    },
    watch: {
        localmodel: {
            handler() {
                this.$emit('update-model', this.localmodel)
            },
            deep: true
        }
    },
}
</script>
